import { Controller } from "@hotwired/stimulus"
import QRCode from "qrcode"
import Encoding from "encoding-japanese"

const CHAR_LIMIT = 500

export default class extends Controller {
  static targets = ["textarea", "modal", "carousel", "counter", "preview"]

  connect() {
    if (new URLSearchParams(window.location.search).get("show_qr") === "1") {
      history.replaceState(null, "", window.location.pathname)
      this.show()
    }
  }

  async show() {
    const text = this.textareaTarget.value.trim()
    if (!text) return

    this.modalTarget.classList.remove("hidden")
    await this._renderQR(text)
  }

  // テキストを500文字単位で分割
  _splitText(text) {
    const chunks = []
    for (let i = 0; i < text.length; i += CHAR_LIMIT) {
      chunks.push(text.slice(i, i + CHAR_LIMIT))
    }
    return chunks
  }

  async _renderQR(text) {
    const chunks = this._splitText(text)
    const total = chunks.length
    const qrSize = Math.min(270, window.innerWidth - 80)
    const opts = { width: qrSize, margin: 2, errorCorrectionLevel: "L" }

    // カルーセルをリセット
    this.carouselTarget.innerHTML = ""

    for (let i = 0; i < chunks.length; i++) {
      const sjisArray = Encoding.convert(Encoding.stringToCode(chunks[i]), { to: "SJIS", from: "UNICODE" })

      const slide = document.createElement("div")
      slide.className = "flex-shrink-0 flex flex-col items-center gap-2 snap-center"
      slide.style.width = `${qrSize}px`

      const label = document.createElement("div")
      label.className = "text-sm font-bold text-gray-700"
      label.textContent = `${i + 1} / ${total}`

      const canvas = document.createElement("canvas")

      slide.appendChild(label)
      slide.appendChild(canvas)
      this.carouselTarget.appendChild(slide)

      try {
        await QRCode.toCanvas(canvas, [{ data: new Uint8Array(sjisArray), mode: "byte" }], opts)
      } catch {
        canvas.getContext("2d").clearRect(0, 0, qrSize, qrSize)
        label.textContent += " (生成失敗)"
      }
    }

    // カルーセル幅をQR1枚分に固定
    this.carouselTarget.style.width = `${qrSize}px`

    this.counterTarget.textContent = total > 1 ? `${total}枚に分割` : ""
    this.previewTarget.textContent = text
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }
}
